import React from "react";
import MirsTable from "components/general/table/Table";
import {speedSeedingHeatsColumns } from "./Columns";
import { isSpeedSeeding, isSpeedQualification, isSemis } from "components/sports/clb/helper/ClbHelpers";
import { isLiveStatus, isStartListStatus, isFinishedStatus } from "helpers/status";
import LoaderSubComponent from "components/general/LoaderSubComponent";
import Label from "components/general/Label";
import CaptionTable from "components/general/table/CaptionTable";
import Status from "components/presentation/Status";

const Heats = ({data, extraData, extraData2, mirs_competition, mirs_language, mirs_rsc, breakPoint}) => {

    const resultStatus = data?.results?.status?.code;
    const scheduleStatus = data?.results?.schedule?.status?.code;

    const isStartList = isStartListStatus(resultStatus);
    const isLive = isLiveStatus(resultStatus);
    const isFinished = isFinishedStatus(resultStatus);

    const isMobile = breakPoint === "sm" || breakPoint === "xs" 

    const currents = data?.results?.extendedInfos?.filter(ei => ei?.ei_code === 'CURRENT')?.map(ei => ({code: ei?.ei_value, pos: ei?.ei_pos}))

    const items = data?.results?.items;
    const reatData = data?.results?.extendedInfos?.filter(ei => ei?.ei_code === 'HEAT' &&  ei?.ei_type === 'SPEED')?.map(ei => {
        const a = ei?.extensions?.find(e => e?.eie_pos === '1')?.eie_value;
        const b = ei?.extensions?.find(e => e?.eie_pos === '2')?.eie_value;
        const resA = items.find(i => i?.participant?.code === a);
        const resB = items.find(i => i?.participant?.code === b);
        return ({
          value: ei?.ei_value,
          code: ei?.ei_pos,
          sortOrder: Number(ei?.ei_pos),
          participantA: resA?.participant,
          bibA: resA?.bib,
          participantB: resB?.participant,
          bibB: resB?.bib,
        })
    })

    const renderRowSubComponent = React.useCallback(({ row }) => {
        let componentExpanded;
        if (isSpeedSeeding(mirs_rsc)) {
          componentExpanded = () => {}

        } else if (isSpeedQualification(mirs_rsc)) {
          componentExpanded = () => {}
        }

        return (
          <LoaderSubComponent component={componentExpanded} />
        )
        // eslint-disable-next-line
      }, [resultStatus]);
    
    const caption = (<CaptionTable
      rightCol={<Status typeToPrint="result" scheduleStatus={scheduleStatus} resultStatus={resultStatus} />} />)
    
    const getColumns = () => {
        let columns = [];
        if(isSpeedSeeding(mirs_rsc)){
            columns = speedSeedingHeatsColumns(isMobile);

        }else if (isSpeedQualification(mirs_rsc)){
          columns = speedSeedingHeatsColumns(isMobile);
        }
        return columns;    
    }

    const getInitialSortBy = () => {
      let initialSortBy = []
      if(isSpeedSeeding(mirs_rsc)){
          initialSortBy = isStartList ? [{ id: 'Heat', desc: false }] : [{ id: 'Heat', desc: false }];      

      }else if(isSpeedQualification(mirs_rsc)){
        initialSortBy = isStartList ? [{ id: 'StartOrder', desc: false }] : [{ id: 'Rank', desc: false }];      
      }
      
      return initialSortBy;
    }

    const getHiddenColumns = () => {
      let hiddenColumns = []
      if(isSpeedSeeding(mirs_rsc)){
        if (isMobile){
          hiddenColumns = isStartList ? ['BibA', 'BibB', 'NOC_A', 'NOC_B'] : ['BibA', 'BibB', 'NOC_A', 'NOC_B'];
        } else {
          hiddenColumns = isStartList ? [] : [];
        }

      } else if (isSpeedQualification(mirs_rsc)) {
        const qualMark = isSemis(mirs_rsc) ? [] : ['QualMark']
        if (isMobile){
          hiddenColumns = isStartList ? ['Rank','StartOrder', 'QualMark'] : isLive ? ['StartOrder','Bib', ...qualMark] : ['StartOrder', 'Bib', ...qualMark];
        } else {
          hiddenColumns = isStartList ? ['Rank', 'QualMark'] : isLive ? [...qualMark] : ['StartOrder', ...qualMark];
        }
      }
      return hiddenColumns;
    }

    const getCurrentIndicator = (row) => {
      let out = '';
      if(isSpeedSeeding(mirs_rsc)){
        const isCurrent = currents ? currents?.find(c => c?.code === row.original?.code) : undefined;
        out =  {className: isCurrent ? 'currentIndicator' : ''}
      } else if (isSpeedQualification(mirs_rsc)){
        const isCurrent = currents ? currents?.find(c => c?.code === row.original?.code) : undefined;
        out =  {className: isCurrent ? 'currentIndicator' : ''}
      }
      return out  
    }

    const getCellCurrentIndicator = (cellInfo) => {
      let out = ''
      if(isSpeedSeeding(mirs_rsc)){
        let isCurrent = currents ? currents?.find(c => c?.code === cellInfo.row.original.participant?.code) : undefined;
        if (isCurrent && cellInfo?.column?.id === 'Boulder' + isCurrent?.pos) {
          out = {className: (cellInfo?.column?.className || '') + ' currentIndicator' }

        } else if (cellInfo?.column?.id?.includes('Boulder')) {
          out = {className: (cellInfo?.column?.className || '')?.replaceAll(' currentIndicator', '')}
        }

      } else if (isSpeedQualification(mirs_rsc)){
        out = ''
      }
      return out  
    }

    return <>
            <MirsTable
                id={`mirs-table-result-${mirs_rsc}`}
                sortable={!isMobile}
                caption={caption}
                data={reatData}
                columns={getColumns()}
                keyRow={"code"}
                initialSortBy={getInitialSortBy()}
                hiddenColumns={getHiddenColumns()}
                renderRowSubComponent={renderRowSubComponent}
                getRowProps={row => { return getCurrentIndicator(row) }}
                getCellProps={cellInfo => {return getCellCurrentIndicator(cellInfo) }}
            />

    </>
}

export default Heats;

